import { useEffect, useRef } from 'react';
import { NativeSupportHandlerV2 } from '@bharatpe/native-support-handler';

import { loadState } from 'utils/LocalStorage';
export default function useInterval(callback: (() => void) | undefined, delay: number | null, txn: string) {
	const savedCallback = useRef();
	// Remember the latest callback.
	useEffect(() => {
		(savedCallback as any).current = callback;
	}, [callback]);
	// Set up the interval.
	useEffect(() => {
		console.log('=======================payment-status=======================', (txn as any)?.data?.paymentStatus);
		function tick() {
			if ((txn as any)?.data?.paymentStatus !== 'SUCCESS' && (txn as any)?.data?.paymentStatus !== 'FAILURE') {
				(savedCallback as any).current();
			}
			if ((txn as any)?.data?.paymentStatus === 'SUCCESS' || (txn as any)?.data?.paymentStatus === 'FAILURE') {
				const deviceType = loadState('deviceType', true);
				if (deviceType === 'webview') {
					NativeSupportHandlerV2.openDeeplink((txn as any)?.data?.redirectURIDeeplink);
					return;
				}
				if (deviceType === 'browser' && (txn as any)?.data?.redirectURI) {
					window.open((txn as any)?.data?.redirectURI, '_top');
					return;
				}
			}
		}
		if (delay !== null) {
			const id = setInterval(tick, delay);
			return () => clearInterval(id);
		}
	}, [delay, txn]);
}
